import api from './api'

const BASE = '/partner-licensings/:partnerLicensingId/clinical-cares'

export default {
  countStatus() {
    return api.get(`${BASE}/count-status`)
  },

  list(params = {}) {
    const { status, ...filters } = params

    if (status) {
      return api.get(`${BASE}/${status}/list`, { params: filters })
    }

    return api.get(BASE, { params: filters })
  },
  allowedClinics() {
    return api.get(`${BASE}/allowed-clinics`)
  },
  changePriority(id, body) {
    return api.patch(`/partner-licensings/:partnerLicensingId/clinical-cares/${id}/priority`, body)
  },
  summary(clinicId, day) {
    return api.get(`/partner-licensings/:partnerLicensingId/clinical-cares/${clinicId}/summary`, { params: { day } })
  },
  inHospital(clinicId) {
    return api.get(`/partner-licensings/:partnerLicensingId/clinical-cares/${clinicId}/in-hospital`)
  },
  summaryDates() {
    return api.get(`${BASE}/summary-dates`)
  },
  show(id) {
    return api.get(`${BASE}/${id}`)
  },
  create(body) {
    return api.post(BASE, body)
  },
  setAnimal(id, body) {
    return api.post(`${BASE}/${id}/set-animal`, body)
  },
  approve(id, body) {
    return api.post(`${BASE}/${id}/approve`, body)
  },
  screening(id, body) {
    return api.post(`${BASE}/${id}/screening`, body)
  },
  changeClinic(id, form) {
    return api.post(`${BASE}/${id}/change-clinical-care-clinic`, form)
  },
  pullout(id, body) {
    return api.post(`${BASE}/${id}/pullout`, body)
  },
  release(id, body) {
    return api.post(`${BASE}/${id}/release`, body)
  },
  done(id, body) {
    return api.post(`${BASE}/${id}/done`, body)
  },
  cancel(id, body) {
    return api.post(`${BASE}/${id}/cancel`, body)
  },
  death(id, body) {
    return api.post(`${BASE}/${id}/death`, body)
  },
  reject(id, body) {
    return api.post(`${BASE}/${id}/reject`, body)
  },
  revision(id, body) {
    return api.post(`${BASE}/${id}/revision`, body)
  },
  correction(id, body) {
    return api.post(`${BASE}/${id}/correction`, body)
  },
  messages(id, params = {}) {
    return api.get(`${BASE}/${id}/messages`, { params })
  },
  addMessage(id, body) {
    return api.post(`${BASE}/${id}/messages`, body)
  },
  conversations(params = {}) {
    return api.get(`${BASE}/messages`, { params })
  },
  readMessages(id) {
    return api.post(`${BASE}/${id}/messages/read`)
  },
  currentTerms() {
    return api.get('/partner-licensings/:partnerLicensingId/clinical-cares/terms/current')
  },
  updateCurrentTerms(clinicalCareTerms) {
    return api.put('/partner-licensings/:partnerLicensingId/clinical-cares/terms/current', { clinicalCareTerms })
  },
}
